import React from 'react';

import { DraftStatus, DraftStatusSmartHome, DraftStatusType } from '../../model/draft';
import Status, { Color } from './Status';
import { Channel } from '../../model/skill';
import { draftStatusLabels } from '../../locale/ru/draftStatus';

type ColorSet<TStatus extends string> = Record<TStatus, Color>;

const commonColors: ColorSet<DraftStatus> = {
    [DraftStatus.InDevelopment]: 'green',
    [DraftStatus.ReviewRequested]: 'green',
    [DraftStatus.ReviewApproved]: 'green',
    [DraftStatus.DeployRequested]: 'green',
};

const smartHomeColors: ColorSet<DraftStatusSmartHome> = {
    [DraftStatusSmartHome.InDevelopment]: 'green',
    [DraftStatusSmartHome.ReviewRequested]: 'green',
    [DraftStatusSmartHome.MeetingApproval]: 'green',
    [DraftStatusSmartHome.WaitingForTesting]: 'green',
    [DraftStatusSmartHome.DevicesTesting]: 'green',
    [DraftStatusSmartHome.DevicesTestingCompleted]: 'green',
    [DraftStatusSmartHome.ReviewApproved]: 'green',
    [DraftStatusSmartHome.DeployRequested]: 'green',
};

const colors = {
    [Channel.AliceSkill]: commonColors,
    [Channel.Thereminvox]: commonColors,
    [Channel.SmartHome]: smartHomeColors,
    [Channel.TvApp]: commonColors,
};

export interface Props<TChannel extends Channel> {
    status: DraftStatusType<TChannel>;
    channel: TChannel;
}

export function DraftStatusComponent<T extends Channel>({ status, channel }: Props<T>) {
    try {
        const color = (colors as any)?.[channel]?.[status] || colors[Channel.AliceSkill][DraftStatus.InDevelopment];
        const message =
            (draftStatusLabels as any)?.[channel]?.[status] ||
            draftStatusLabels[Channel.AliceSkill][DraftStatus.InDevelopment];
        return <Status color={color} message={message} />;
    } catch (error) {
        console.error('@DraftStatusComponent ', status, channel, error);
    }
    return null;
}
